import jsPDF from "jspdf";

export const generateLeaveCancellationPDF = (data) => {
    const doc = new jsPDF("p", "mm", "a4");

    const left = 25;
    let y = 30;
    const lineGap = 9;

    /* =========================
       TITLE
    ========================== */
    doc.setFont("Times", "Bold");
    doc.setFontSize(16);
    doc.text("LEAVE CANCELLATION REQUEST", 105, y, { align: "center" });

    y += 15;

    /* =========================
       TO ADDRESS
    ========================== */
    doc.setFont("Times", "Normal");
    doc.setFontSize(12);
    doc.text(
        `To,
The ${data.applying_to === "MD" ? "Managing Director" : "General Manager"}
Jharkhand Tourism Development Corporation Limited
Ranchi, Jharkhand`,
        left,
        y
    );

    y += 30;

    /* =========================
       SUBJECT
    ========================== */
    doc.setFont("Times", "Bold");
    doc.text("Subject: Request for cancellation of approved leave", left, y);

    y += lineGap * 2;

    /* =========================
       BODY
    ========================== */
    doc.setFont("Times", "Normal");

    const bodyText = `
Sir/Madam,

I respectfully submit that I, ${data.EmployeeName}, presently working as
${data.Designation} in the ${data.Department}, Jharkhand Tourism Development
Corporation Limited, had earlier been granted ${data.LeaveType} leave for
${data.TotalDays} day(s) from ${formatDate(data.StartDate)} to
${formatDate(data.EndDate)}.

Due to ${data.CancellationReason}, I request that the aforesaid leave
may kindly be cancelled.

I therefore request you to kindly approve the cancellation of the leave
mentioned above.

`;

    doc.text(bodyText.trim(), left, y, {
        maxWidth: 160,
        lineHeightFactor: 1.6,
    });

    /* =========================
       EMPLOYEE SIGNATURE BLOCK
    ========================== */
    doc.text(
        `Date: ${formatDate(data.CancellationRequestedDate)}`,
        left,
        235
    );

    doc.text(
        `${data.EmployeeName}`,
        140,
        225
    );

    doc.setFont("Times", "Italic");
    doc.setFontSize(10);
    doc.text(
        `(Cancellation requested via the JTDCL portal)`,
        140,
        233,
        { align: "center" }
    );

    /* =========================
       AUTHORITY SIGNATURE BLOCK
    ========================== */
    doc.setFont("Times", "Normal");
    doc.setFontSize(12);

    doc.text(
        `Signature of ${data.applying_to === "MD" ? "Managing Director" : "General Manager"}`,
        left,
        275
    );

    doc.text(
        `_______________________________`,
        left,
        281
    );

    /* =========================
       SAVE
    ========================== */
    doc.save(
        `${data.EmployeeName}_Leave_Cancellation_${formatDate(data.CancellationRequestedDate)}.pdf`
    );
};

const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};
